import CollaborationInput from "../input/index.vue";
import CollaborationSelect from "../select/index.vue";
import CollaborationPhone from "../phone/index.vue";
import CollaborationFileUpload from "../file/index.vue";
import { mapActions } from "vuex";
import validation from "@/mixins/validation";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";
import { mapKeys, snakeCase, debounce } from "lodash";
import { globalLoader } from "@/helpers/variables";

const typeOfActivityList = [
      { key: 'dealer', title: 'Дилер' },
      { key: 'dermatologist', title: 'Дерматолог' },
      { key: 'online_store', title: 'Інтернет-магазин' },
      { key: 'beauty_clinic', title: 'Клініка краси' },
      { key: 'cosmetologist_injection_nurse', title: 'Косметолог-ін’єкціоніст' },
      { key: 'aesthetic_medicine_doctor', title: 'Лікар естетичної медицини' },
      { key: 'doctor', title: 'Лікар' },
      { key: 'masseur', title: 'Масажист' },
      { key: 'network_clinic', title: 'Мережева клініка' },
      { key: 'network_salon', title: 'Мережевий салон' },
      { key: 'private_practice_cosmetologist', title: 'Приватний кабінет - косметолог' },
      { key: 'beauty_salon_studio', title: 'Салон краси/студія' },
      { key: 'physical_store', title: 'Фізичний магазин' },
  ]

export default {
  name: 'CollaborationForm',
  components: {
    CollaborationInput,
    CollaborationSelect,
    CollaborationPhone,
    CollaborationFileUpload
  },
  mixins: [validation],
  data() {
    return {
      currentLanguage: localStorage.getItem('app_locale'),
      isLoading: false,
      payload: {
        register_mode: 'professional',
        phone_country: 'UA',
        email: '',
        name: '',
        secondName: '',
        phone: '',
        work: '',
        city: "",
        areaRef: "",
        files: [],
        skipPhoneChecking: true,
        typeOfActivity: null,
        typeOfActivityList: null,
        withoutProneConfirm: true,
        registered_from: "spivpracya",
      },
      cities: null,
      validationErrors: {},
    }
  },
  watch: {
    'payload.email'() {
      delete this.validationErrors.email
    },
    'payload.name'() {
      delete this.validationErrors.name
    },
    'payload.secondName'() {
      delete this.validationErrors.secondName
    },
    'payload.phone'() {
      delete this.validationErrors.phone
    },
    'payload.work'() {
      delete this.validationErrors.work
    },
    'payload.city'() {
      delete this.validationErrors.city
    },
    'payload.areaRef'() {
      delete this.validationErrors.areaRef
    },
    'payload.files'() {
      delete this.validationErrors.files
    },
  },
  validations() {
    const validation = {
      payload: {
        name: {
          required,
        },
        lastName: {
          required,
        },
        email: {
          required,
          email
        },
        work: {
          required,
        },
        city: {
          required,
        },
        files: {
          required
        },
        phone: {
          required,
          minLength: minLength(12),
          maxLength: maxLength(12),
        }
      },
    }
    return validation
  },
  async created() {
    this.cities = await this.fetchCities({ Limit: 50 })
  },
  computed: {
    nameErrors() {
      return this.computeErrors('payload', 'name', {
        required: 'validationRequired',
      })
    },
    cityErrors() {
      return this.computeErrors('payload', 'city', {
        required: 'validationRequired',
      })
    },
    lastNameErrors() {
      return this.computeErrors('payload', 'lastName', {
        required: 'validationRequired',
      })
    },
    emailErrors() {
      return this.computeErrors('payload', 'email', {
        required: 'validationRequired',
        email: 'validationEmail',
      })
    },
    workErrors() {
      return this.computeErrors('payload', 'work', {
        required: 'validationRequired',
      })
    },
    phoneErrors() {
      return this.computeErrors('payload', 'phone', {
        required: 'validationRequired',
        minLength: 'inputCorrectPhoneNumber',
        maxLength: 'inputCorrectPhoneNumber',
      })
    },
    filesErrors() {
      return this.computeErrors('payload', 'files', {
        required: 'validationRequired',
      })
    },
    typeOfActivityOptions() {
      return typeOfActivityList.map((activity) => ({
        value: activity.key,
        text: this.$t(activity.title),
      }))
    },
    cityOptions() {
      if (!this.cities) return
      return this.cities.data.map(city => {
        return {
          value: city.Ref,
          area: city.Area,
          text: city.Description,
        }
      })
    },
  },
  methods: {
    ...mapActions({
      registrations: 'auth/REGISTRATION',
      getCountries: 'auth/GET_COUNTRIES',
      fetchTowns: "order/NOVA_POSHTA_GET_TOWNS",
    }),
    async fetchCities(payload) {
      const formData = JSON.stringify({
        modelName: "Address",
        calledMethod: "getCities",
        apiKey: process.env.VUE_APP_NOVAPOSHTA_API_KEY,
        methodProperties: {
          ...payload
        },
      });

      return await this.fetchTowns(formData)
    },
    handleTypeOfActivitySelect(e) {
      this.payload.typeOfActivity = e.map((item) => item.value)
      this.payload.typeOfActivityList = e
    },
    handleCitySelect(e) {
      this.payload.areaRef = e.area
      this.payload.city = e.text
    },
    parsFormData(obj) {
      let fd = new FormData()
      for (let i in obj) {
        if (i === 'type_of_activity_list') {
          fd.append(i, JSON.stringify(obj[i]))
        }
        else if (i === 'phone_country') {
          fd.append('phone_country', 'UA')
        }
        else if (i === 'files') {
          for (let j in obj[i]) {
            fd.append(`files[${j}]`, obj[i][j])
          }
        } else {
          fd.append(i, obj[i])
        }
      }
      return fd
    },

    transformData() {
      let parsedNumber = ''
      try {
        const phone = this.payload.phone
        if (phone) {
          parsedNumber = parsePhoneNumberFromString(phone)
        }
      } catch (error) {
        console.error('Error parsing phone number:', error)
        parsedNumber = ''
      }

      if (parsedNumber) {
        this.payload.phone_country = parsedNumber.country
      } else {
        this.payload.phone_country = ''
      }

      this.payload.confirm_token = this.verifyCodeResponse?.confirmToken
      return mapKeys(this.payload, (value, key) => snakeCase(key))
    },

    handleCityInput: debounce(async function (e) {
      console.log(e);
      if (e.length < 3) {
        this.cities = await this.fetchCities({ Limit: 50 })
        return
      }
      this.cities = await this.fetchCities({
        Limit: 50,
        FindByString: e,
        Language: 'ua',
      })
    }, 500),

    handleSuccessRegister() {
      this.payload = {
        register_mode: 'professional',
        name: '',
        lastName: '',
        email: '',
        phone: '',
        phone_country: '',
        city: "",
        areaRef: "",
        files: [],
      }

      window.dataLayer.push({
        'event' : 'sign_up',
        'eventCategory' : 'sign_up',
        'eventAction' : 'sign_up',
      });

      // eslint-disable-next-line no-undef
      fbq('track', 'sign_up');

      this.$v.$reset()
      this.$refs.typeOfActivitySelect.reset()
      this.$refs.cityOptions.reset()
      this.$refs.phoneInput.reset()
      this.validationErrors = {}
      this.$toasted.success(this.$t('collaborationFormSuccess'))
    },

    async handleSubmit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log('Validation errors:', this.$v)
        return
      }
      this.isLoading = true
      try {
        await this.registrations(this.parsFormData(this.transformData()))
        this.handleSuccessRegister()
      } catch (error) {
        if (error.status === 422) {
          this.validationErrors = error.data.errors
        }
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
